export type FormFieldType = "text" | "numeric" | "dropdown";

export type FormFieldDef = {
  id: string;
  type: FormFieldType;
  label: string;
  placeholder?: string;
  required?: boolean;
  options?: string[];
  order?: number;
};

export type FormSectionDef = {
  id: string;
  title: string;
  order?: number;
  fields: FormFieldDef[];
};

export type FormSchemaJson = {
  sections: FormSectionDef[];
  logoUrl?: string;
  sourceType?: string;
};

export type FormBuilderSavePayload = {
  name: string;
  description: string | null;
  schemaJson: FormSchemaJson;
  notifyEmails: string[];
  isAvailable: boolean;
};

export const FIELD_TYPE_OPTIONS = [
  { value: "text", label: "טקסט" },
  { value: "numeric", label: "מספרי" },
  { value: "dropdown", label: "בחירה (Dropdown)" },
];

export const SOURCE_TYPE_OPTIONS = [
  { value: "link", label: "קישור" },
  { value: "ivr", label: "מענה קולי" },
  { value: "nedarim_plus", label: "נדרים פלוס" },
];

export const newFieldId = () => `f_${Math.random().toString(36).slice(2, 9)}`;

export const emptySection = (): FormSectionDef => ({
  id: newFieldId(),
  title: "מקטע חדש",
  fields: [],
});

export const emptyField = (): FormFieldDef => ({
  id: newFieldId(),
  type: "text",
  label: "שדה חדש",
  placeholder: "",
  required: false,
  options: [],
});

export function parseNotifyEmails(raw: string): string[] {
  return raw
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
}

export function readFormSchema(schemaJson: Record<string, unknown> | null | undefined): FormSchemaJson {
  const sectionsRaw = schemaJson?.sections;
  const sections = Array.isArray(sectionsRaw)
    ? (sectionsRaw as FormSectionDef[]).map((s) => ({
        ...s,
        id: s.id || newFieldId(),
        fields: (s.fields || []).map((f) => ({
          ...f,
          id: f.id || newFieldId(),
        })),
      }))
    : [];
  return {
    sections,
    logoUrl: typeof schemaJson?.logoUrl === "string" ? schemaJson.logoUrl : "",
    sourceType:
      typeof schemaJson?.sourceType === "string" ? schemaJson.sourceType : "link",
  };
}
